import { defineStore } from 'pinia';
import api from '@/api/api';
import type { ZAssignment } from '@schemas/assignment.schemas';
import assignmentAPI from "@/api/assignment";
import type {AssignmentStatus} from "@typesDef/assignment.types";

export const useAssignmentsStore = defineStore('assignments', {
    state: () => ({
        assignments: [] as ZAssignment[],
        currentAssignment: null as ZAssignment | null,
        eventAssignment: null as ZAssignment | null
    }),
    getters: {
        getAssignmentForEvent: (state) => (eventId: string) =>
            state.assignments.find(assignment => assignment.eventId === eventId)
    },
    actions: {
        clearMyData(): void {
            // both are only used in the context of the current loggedin user
            this.assignments = [];
            this.currentAssignment = null;
            this.eventAssignment = null;
        },
        async fetchAssignment(assignmentId: string): Promise<ZAssignment> {
            log.debug(`fetchAssignment(${assignmentId})`);
            this.currentAssignment = this.assignments.find(app => app._id === assignmentId) ||
                await api.getDocument<ZAssignment>('assignments', assignmentId);
            return this.currentAssignment;
        },
        async fetchAssignments(query: Record<string, any> = {}): Promise<ZAssignment[]> {
            this.assignments = await api.getDocuments<ZAssignment>('assignments', query);
            return this.assignments;
        },
        async fetchAssignmentByEventId(eventId: string): Promise<ZAssignment> {
            log.debug(`fetchAssignmentByEventId(${eventId})`);
            const found = this.getAssignmentForEvent(eventId);
            log.debug(`found assignment: ${found}`);

            if (found) {
                this.eventAssignment = found;
            } else {
                this.eventAssignment = await api.getDocument<ZAssignment>('assignments/event/', eventId );
            }
            return this.eventAssignment;
        },
        async addAssignment(assignment: ZAssignment): Promise<ZAssignment> {
            const newAssignment = await api.postDocument<ZAssignment>('assignments', assignment);
            this.assignments.push(newAssignment);
            return newAssignment;
        },
        async updateAssignment(assignment: Partial<ZAssignment>): Promise<ZAssignment> {
            const updatedAssignment = await api.putDocument<ZAssignment>('assignments', assignment);
            this.assignments = this.assignments.map(assignment => assignment._id === updatedAssignment._id ? updatedAssignment : assignment);
            this.currentAssignment = this.currentAssignment?._id === updatedAssignment._id ? updatedAssignment : this.currentAssignment;
            return updatedAssignment;
        },
        async updateStatus(assignmentId: string, status: AssignmentStatus): Promise<ZAssignment> {
            const updatedAssignment = await assignmentAPI.updateStatus(assignmentId, status);
            //update applications
            this.assignments = this.assignments.map(asig => asig._id === updatedAssignment._id ? updatedAssignment : asig);
            // update currentAssignment
            // TODO use storeHelper
            if (this.currentAssignment && this.currentAssignment?._id === updatedAssignment._id) {
                this.currentAssignment.status = updatedAssignment.status;
                this.currentAssignment.updatedAt = updatedAssignment.updatedAt;
            }
            return updatedAssignment;
        },

        async removeAssignment(assignmentId: string): Promise<void> {
            await api.deleteDocument<ZAssignment>('assignments', assignmentId);
            this.assignments = this.assignments.filter(assignment => assignment._id !== assignmentId);
        }
    }
});
